<div class="col-sm-2 filter">
    <div class="filter_view-part" (click)="showDropdown = !showDropdown">Filter</div>
    <div class="filter_dropdown" [hidden]="!showDropdown">
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input [(ngModel)]="filterValues.show_moved_out" type="checkbox" id="archivedCheckbox" (change)="filterChanged()">
                <label for="archivedCheckbox"><svg-checked></svg-checked></label>
                <span>Archived</span>
            </label>
        </div>

        <hr *ngIf="directoryService.currentTabId == 'residents'">

        <div class="types-filter-items-wrapper" *ngIf="directoryService.currentTabId == 'residents'">
            <div class="m-b-xs filter-checkbox" *ngFor="let type of directoryService.residentOccupancyTypes; let index = index;">
                <label class="img-checkbox">
                    <input [(ngModel)]="filterValues.role[type.code]" type="checkbox" id="{{type.code}}" (change)="filterChanged()">
                    <label for="{{type.code}}"><svg-checked></svg-checked></label>
                    <span>{{type.name}}</span>
                </label>
            </div>
            <hr *ngIf="directoryService.groups.length">
            <div class="m-b-xs user-group-checkbox" *ngFor="let group of directoryService.groups; let index = index;">
                <label class="img-checkbox">
                    <input [(ngModel)]="filterValues.group_id[group.id]" type="checkbox" id="user-group-{{group.id}}" (change)="filterChanged()">
                    <label for="user-group-{{group.id}}"><svg-checked></svg-checked></label>
                    <span>{{group.itemName}}</span>
                </label>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/directory-archived-items-filter/directory-archived-items-filter.component.html